import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import useToggle from 'next/hooks/use-toggle';
import { Select, Button } from 'next/components/ui';
import { EventShape } from 'next/entities/rules';

import { ConditionsContext } from './ConditionsContext';
import { TimeframeOptions } from './TimeframeOptions';
import { ClauseWrapper, Clause } from './styled';

const NEGATED_OPTIONS = [
  { label: 'has occurred', value: false },
  { label: 'has not occurred', value: true },
];

export const EventClause = ({
  conditions,
  negated,
  onChange,
  onChangeNegated,
}) => {
  const [showOptions, toggleShowOptions] = useToggle(false);

  const {
    event: { event, operator = '', times = 1, value = 1 },
  } = conditions;

  const { eventOptions } = useContext(ConditionsContext);

  const handleChange = changes => {
    onChange({ event: { ...conditions.event, ...changes } });
  };

  const handleEventChange = ({ value: newEvent }) =>
    handleChange({ event: newEvent });

  const options = [...eventOptions];

  if (event && !options.some(({ value: eventId }) => eventId === event)) {
    options.push({
      label: event,
      value: event,
    });
  }

  return (
    <ClauseWrapper>
      <Clause>
        <Select
          value={options.find(
            ({ value: optionEvent }) => optionEvent === event
          )}
          options={options}
          onChange={handleEventChange}
          portal
        />
        <Select
          value={negated ? NEGATED_OPTIONS[1] : NEGATED_OPTIONS[0]}
          options={NEGATED_OPTIONS}
          onChange={({ value: isNegated }) => void onChangeNegated(isNegated)}
          portal
        />
        <Button kind="secondary" onClick={toggleShowOptions}>
          {showOptions ? 'Hide' : 'Show'} options
        </Button>
      </Clause>
      {showOptions && (
        <TimeframeOptions
          times={times}
          operator={operator}
          value={value}
          onChange={handleChange}
        />
      )}
    </ClauseWrapper>
  );
};

EventClause.propTypes = {
  conditions: PropTypes.oneOfType([
    EventShape,
    PropTypes.exact({ not: PropTypes.arrayOf(EventShape) }),
  ]),
  negated: PropTypes.bool,
  onChange: PropTypes.func,
  onChangeNegated: PropTypes.func,
};
